"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteTracker = void 0;
var react_1 = __importStar(require("react"));
var client_provider_1 = require("./client-provider");
/**
 * Automatically track page calls when the Next.js router changes.
 */
function RouteTracker(props) {
    var children = props.children, router = props.router, appName = props.appName, _a = props.defaultPageProperties, defaultPageProperties = _a === void 0 ? {} : _a;
    var analytics = (0, client_provider_1.useSegmentClientContext)().client;
    var _b = (0, react_1.useState)(false), hasInitialPageView = _b[0], setHasInitialPageView = _b[1];
    var pathname = router.pathname, route = router.route, basePath = router.basePath, asPath = router.asPath;
    var _c = (0, react_1.useState)(false), hasRouteChanged = _c[0], setRouteChanged = _c[1];
    var routerIsReady = router.isReady;
    var pageProperties = (0, react_1.useMemo)(function () {
        return __assign({ pathname: pathname, asPath: asPath, route: route, basePath: basePath, appName: appName }, defaultPageProperties);
    }, [pathname, asPath, route, basePath, appName, defaultPageProperties]);
    // We deliberately do not want this to trigger on route changes because we have
    // the events hooked up below which are more reliable.
    (0, react_1.useEffect)(function () {
        if (hasInitialPageView || !routerIsReady)
            return;
        setHasInitialPageView(true);
        analytics.page({
            properties: pageProperties,
        });
    }, [analytics, hasInitialPageView, pageProperties, routerIsReady]);
    // Call analytics.page whenever there is a page transition
    (0, react_1.useEffect)(function () {
        var onChange = function () {
            // Next.js <12.2 will fire the routeChangeComplete event on any page that
            // uses a URL param on the initial page load. It won't do this on pages
            // that DONT use a URL param.
            if (!hasInitialPageView)
                return;
            setRouteChanged(true);
        };
        router.events.on('routeChangeComplete', onChange);
        return function () {
            router.events.off('routeChangeComplete', onChange);
        };
    }, [router, hasInitialPageView]);
    // This is a bit of a hack because the route change event is fired before the properties on
    // the router are updated. This allows us to avoid calling analytics.page twice.
    (0, react_1.useEffect)(function () {
        if (hasRouteChanged) {
            analytics.page({
                properties: pageProperties,
            });
            setRouteChanged(false);
        }
    }, [hasRouteChanged, pageProperties, analytics]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
}
exports.RouteTracker = RouteTracker;
